import Vue, { PluginObject } from 'vue';
import IconChatComponent from './IconChat.vue';
import IconIntroComponent from './IconIntro.vue';
import IconPrivateMeetingComponent from './IconPrivateMeeting.vue';
import IconMedalComponent from './IconMedal.vue';
import IconEnvelopComponent from './IconEnvelop.vue';
import IconPhoneComponent from './IconPhone.vue';
import IconCalendarComponent from './IconCalendar.vue';
import IconCloseComponent from './IconClose.vue';

export default {
  install(app: typeof Vue): void {
    app.component('IconChat', IconChatComponent);
    app.component('IconIntro', IconIntroComponent);
    app.component('IconPrivateMeeting', IconPrivateMeetingComponent);
    app.component('IconMedal', IconMedalComponent);
    app.component('IconEnvelop', IconEnvelopComponent);
    app.component('IconPhone', IconPhoneComponent);
    app.component('IconCalendar', IconCalendarComponent);
    app.component('IconClose', IconCloseComponent);
  },
} as PluginObject<any>;

export const IconChat = IconChatComponent;
export const IconIntro = IconIntroComponent;
export const IconPrivateMeeting = IconPrivateMeetingComponent;
export const IconMedal = IconMedalComponent;
export const IconEnvelop = IconEnvelopComponent;
export const IconPhone = IconPhoneComponent;
export const IconCalendar = IconCalendarComponent;
export const IconClose = IconCloseComponent;
